import { render } from "./servicios-ofrecidos.vue?vue&type=template&id=6ad9a5c3&scoped=true"
import script from "./servicios-ofrecidos.vue?vue&type=script&lang=js"
export * from "./servicios-ofrecidos.vue?vue&type=script&lang=js"

import "./servicios-ofrecidos.vue?vue&type=style&index=0&id=6ad9a5c3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6ad9a5c3"

export default script